import { CloseOutlined, HistoryOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import type React from 'react';
import type { GetOrderByIdWithDriversWarehousesQuery } from '@/generated/graphql/graphql';
import { Export } from './Export';

interface OrderHeaderProps {
  orderData: NonNullable<GetOrderByIdWithDriversWarehousesQuery['order_by_pk']>;
  onShowHistory: () => void;
  onClose: () => void;
  hasChanges: boolean;
  isLoading: boolean;
  isDisabled?: boolean;
}

export const OrderHeader: React.FC<OrderHeaderProps> = ({
  orderData,
  onShowHistory,
  onClose,
  hasChanges,
  isLoading,
  isDisabled = false,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'start',
        gap: '0 10px',
        position: 'relative',
      }}
    >
      <h2>{orderData.shortCode}</h2>
      <Export orders={[orderData as any]} />

      <Button icon={<HistoryOutlined />} type="primary" shape="circle" onClick={onShowHistory} />

      <Button
        type="primary"
        htmlType="submit"
        disabled={!hasChanges || isLoading || isDisabled}
        loading={isLoading}
        style={{ position: 'absolute', right: 45 }}
      >
        {hasChanges ? 'Save Changes' : 'No Changes'}
      </Button>

      <Button
        style={{ position: 'absolute', right: 0 }}
        onClick={onClose}
        shape="circle"
        icon={<CloseOutlined />}
      />
    </div>
  );
};
